import { MakeCall } from 'ha/services/apiV2/createMakeCall';

export type ActivateUserCall = (token: string) => Promise<{ data: null }>;

export default (makeCall: MakeCall) => (token: string) =>
  makeCall<undefined>('POST', `/api/v2/action/activate`, {
    data: { token },
  });
